import { NotificationsOptions, useNotification } from '@kyvg/vue3-notification';

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export default function useNotifications(group?: string) {
    const { notify } = useNotification();

    type NotificationSettings = {
        title?: string,
        subtitle?: string,
        message?: string,
        errors?: string[] | Record<string, string>,
        maxErrors?: number,
        opts?: NotificationsOptions,
    };

    function showNotification(type: string, settings: NotificationSettings = {}): void {
        notify({
            type: type,
            title: settings.title,
            text: settings.message,
            data: {
                subtitle: settings.subtitle,
                errors: settings.errors,
                maxErrors: settings.maxErrors,
            },
            group: group,
            ...(settings.opts ?? {}),
        });
    }

    function showError(settings: NotificationSettings = {}): void {
        showNotification('error', { title: 'Ошибка!', ...settings });
    }

    function showSuccess(settings: NotificationSettings = {}): void {
        showNotification('success', { title: 'Успешно!', ...settings });
    }

    function showWarning(settings: NotificationSettings = {}): void {
        showNotification('warn', { title: 'Предупреждение!', ...settings });
    }

    return {
        showNotification: showNotification,
        showError: showError,
        showSuccess: showSuccess,
        showWarning: showWarning,
    };
}
